module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Cooking/Knife&fork#2-d02130e3d78fe42e5423fce365f828e0.svg";